import { navigate } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { GatsbyHrefLink } from '../gatsby-href-link';
import { LinkContextResult, LinkProvider as Provider } from '@shapeable/ui';

export const gatsbyLinkContext: LinkContextResult = {
  Link: GatsbyHrefLink,
  // @ts-ignore
  navigate
};

export const LinkProvider: React.FC<any> = ({ children }) => {
  return <Provider value={gatsbyLinkContext}>{children}</Provider>;
};